import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { addGlobalComponent, addGlobalProperties, initWindow } from '@/append'
import webviewCall from '@/utils/webviewCall'

const main = async () => {
  await webviewCall.init()
  // initWindow()
  const app = createApp(App)
  app.use(router)
  app.use(store)
  addGlobalComponent(app)
  addGlobalProperties(app)
  if (window.isWebview) {
    webviewCall.getNotify('token').then(token => {
      console.log('___token', token)
      store.commit('user/setToKen', token)
    })
  }

  router.isReady().then(async () => {
    app.mount('#app')
  })
}

main()